import React, {Component} from 'react'
import {api} from "../../service/api.service";
import {extendObservable} from "mobx";
import withRouter from "../../components/withRouter";
import LoadingPageOverlay from "../../components/LoadingPageOverlay";
import {observer} from "mobx-react";
import { Alert } from 'antd';
import t from "../../service/translate.service";

class OcCalculationsPreview extends Component {
  constructor(props) {
    super(props)

    extendObservable(this, {
      loading: false,
      error: false,
      document: null,
    })
  }

  componentDidMount = () => {
    window.scrollTo(0, 0)
    this.setDocument();
  }

  async getDocument(contractNumber, docId) {
    try {
      this.error = false
      const res = await api.get(`/contract/${contractNumber}/documents/ZOC_CALCULATION/${docId}`, {
        responseType: 'blob',
      })
      return res.data
    } catch (err) {
      this.error = true
    }
  }

  setDocument = async () => {
    this.loading = true;
    const { contractNumber, docId } = this.props.useParams;
    this.document = await this.getDocument(contractNumber, docId);
    this.loading = false;
  }

  render() {
    if (this.loading) {
      return (<LoadingPageOverlay/>)
    }
    return (
      <div>
        {this.error && <Alert message={t.SOMETHING_WENT_WRONG} type="error" style={{ marginTop: "12px", marginBottom: "12px" }} aria-live="assertive" role='alert' />}
        <div className="position-relative" style={{ minHeight: "500px" }}>
          <div className="document-preview">
            <div className="text-center">
              {this.document && (
                <iframe 
                  title="Document Viewer" 
                  src={URL.createObjectURL(this.document)} 
                  toolbar="false" 
                  aria-label={t.PREVIEW_DOCUMENT}
                  style={{ width: "100%", height: "100%" }} 
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(observer(OcCalculationsPreview))